import { CanadaMap } from "@/components/CanadaMap";
import { H1, H2 } from "@/components/Heading";
import { OverdosePlanningCallout } from "@/components/OverdosePlanningCallout";
import { translations } from "@/constants/translations";
import { renderInnerHtml } from "@/helpers/dom";
import { useAppNavigate } from "@/routing/useAppNavigate";
import { useStore } from "@/store";
import type { Province } from "@/store/types/province";
import { telemetry } from "@/telemetry";
import { Stack } from "@chakra-ui/react";
import { observer } from "mobx-react";
import React from "react";
import { useEffectOnce } from "usehooks-ts";

export const SelectProvincePage = observer(() => {
  const navigate = useAppNavigate();
  const {
    setOrderData,
    orderData,
    setActiveProvinceId,
    activeLanguage,
    ga4Store,
  } = useStore();
  const provinceTranslations = translations.common.provinces[activeLanguage];
  const language = translations.pages["welcome"][activeLanguage];

  useEffectOnce(() => {
    setActiveProvinceId(undefined);
    setOrderData({
      ...orderData,
      isActive: false,
    });
  });

  const handleClick = (province: Province) => {
    setActiveProvinceId(province);

    let route: any;

    if (
      [
        "ON",
        "BC",
        "SK",
        "MB",
        "AB",
        "YT",
        "NT",
        "NL",
        "NB",
        "NU",
        "PEI",
      ].includes(province)
    ) {
      route = "/order/details";
      setOrderData({ ...orderData, isActive: true });
      telemetry.trackEvent("province_selected", { routed_to: "order" });
    } else {
      route = "/contact";
      telemetry.trackEvent("province_selected", { routed_to: "contact" });
      telemetry.trackEvent("province_unsupported");
    }

    navigate({
      to: route,
      search: (old: any) => ({
        ...old,
        province,
      }),
    });

    ga4Store.selectRegion(province);
  };

  return (
    <Stack spacing="16">
      <Stack
        spacing="8"
        alignItems="center"
        textAlign="center"
      >
        <H1>{renderInnerHtml(language.heading)}</H1>
        <H2>{renderInnerHtml(language.to_place_order)}</H2>
      </Stack>
      <CanadaMap
        onClick={handleClick}
        provinceTranslations={provinceTranslations}
        isInteractive
      />
      <OverdosePlanningCallout />
    </Stack>
  );
});
